/**
 * Created by mestrad on 2018. 06. 28..
 */
const $ = jQuery;

import {createDateFromPrecision} from './datePrecision';

export default class HandlebarsExtension {
    constructor(Handlebars) {
        this.Handlebars = Handlebars;
        this.registerPartial();
        this.registerHelper();
    }

    registerHelper() {
        this.Handlebars.registerHelper({
            yearFormat: function (data, timePrecision, timePrecisionModifier) {
                const momentDate = data != '1000-01-01' ? moment(new Date(data)) : '';
                if (momentDate == '') {
                    return momentDate;
                }
                return momentDate.isValid() ? createDateFromPrecision(momentDate, timePrecision, timePrecisionModifier) : data;
            },
            customFormat: function (data, format, options) {
                var tmp = moment(data);
                return tmp.isValid() && data.length > 4 ? tmp.format(format).replace(/^0+/, '') : data;
            },
            ifEq: function (arg1, arg2, options) {
                return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
            },
            ifNotEq: function (arg1, arg2, options) {
                return (arg1 != arg2) ? options.fn(this) : options.inverse(this);
            },
            joinBy: function (data, key, by = null, delim, max = null, options) {
                if (Array.isArray(data)) {
                    var professionList = [];
                    data.forEach(function (item) {
                        if (item.type == by || by === null) {
                            if (professionList.length < max || max === null) {
                                professionList.push(item[key]);
                            }
                        }
                    });
                    return professionList.join(delim);
                }
                return "";
            },
            dynamicResultListView: function (viewId, context, pages = null) {
                var template = Handlebars.compile(Handlebars.partials[viewId]);
                return new Handlebars.SafeString(template({data: context, pages: pages}));
            },
            hiddenWidgetIfNoResult: function (data, selector) {
                if (data === undefined || data === null || data.length === 0) {
                    document.getElementById(selector).parentElement.classList.add("nnpHidden");
                }
            },
            dynamicFillSlider: function (actualDate, context) {
                var template = Handlebars.compile(Handlebars.partials['slider_item']);
                return new Handlebars.SafeString(template({data: context, actualDate: actualDate}));
            },
            biggerThan: (value, arg, options) => {
                return (value < arg) ? options.fn(this) : options.inverse(this);
            },
            toLowerCase: (str) => {
                return str.toLowerCase();
            },
            truncateString: (string, length) => {
                if (string.length > length) {
                    var stringEnd = '...';
                    return string.slice(0, length) + stringEnd;
                }
                return string;
            },
            validId: (id, options) => {
                return (id && id > 0 && id !== '') ? options.fn(this) : options.inverse(this);
            },
            sortLocationDetails: function ( context, options ) {
                context = JSON.parse( JSON.stringify( context ) );
                var sortOrder = [
                    'country', 'county', 'zip', 'settlement', 'address'
                ];
                var contextSorted = Object.keys( context )
                    .sort( function ( a, b ) {
                        return sortOrder.indexOf( a ) - sortOrder.indexOf( b );
                    } )
                    .reduce( function ( obj, key ) {
                        obj[ key ] = context[ key ];
                        return obj;
                    }, {} );
                return options.fn( contextSorted );
            },
            videoId: function ( url ) {
                var regex = /(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/(?:video\/)?|shorts\/|video\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;
                var m;

                if ( ( m = regex.exec( url ) ) !== null ) {
                    /*
                     m.forEach( function ( match, groupIndex ) {
                     } );
                     */
                    return m[ 1 ] || null;
                }
            },
            checkIf: function ( v1, o1, v2, mainOperator, v3, o2, v4, options ) {
                var operators = {
                    '==': function ( a, b ) {
                        return a == b;
                    },
                    '===': function ( a, b ) {
                        return a === b;
                    },
                    '!=': function ( a, b ) {
                        return a != b;
                    },
                    '!==': function ( a, b ) {
                        return a !== b;
                    },
                    '<': function ( a, b ) {
                        return a < b;
                    },
                    '<=': function ( a, b ) {
                        return a <= b;
                    },
                    '>': function ( a, b ) {
                        return a > b;
                    },
                    '>=': function ( a, b ) {
                        return a >= b;
                    },
                    '&&': function ( a, b ) {
                        return a && b;
                    },
                    '||': function ( a, b ) {
                        return a || b;
                    }
                };
                var a1        = operators[ o1 ]( v1, v2 );
                var a2        = operators[ o2 ]( v3, v4 );
                var isTrue    = operators[ mainOperator ]( a1, a2 );
                return isTrue ? options.fn( this ) : options.inverse( this );
            },
            isURL: function ( string, options ) {
                var regex = /https?:\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%\-\/]))?/;
                var m;
                var match = false;

                if ( (
                         m = regex.exec( string )
                     ) !== null )
                {
                    match = m[ 1 ] || null;
                }
                return match ?
                       decodeURI( options.fn( this ) ) :
                       options.inverse( this );
            },
            getDomain: function ( string, options ) {
                var regex = /https?:\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%\-\/]))?/;
                var m;
                var match = false;

                if ( (
                         m = regex.exec( string )
                     ) !== null )
                {
                    match = m[ 1 ] || null;
                }
                return match ?
                       new URL( options.fn( this ) ).hostname :
                       options.inverse( this );
            }
        });
    }

    registerPartial() {
        if ($("#tmpl-result-list-geo-namecard").html() != undefined)
            this.Handlebars.registerPartial('resultList_geo_namecard', $("#tmpl-result-list-geo-namecard").html());
        if ($("#tmpl-result-list-geo-namecard-item").html() != undefined)
            this.Handlebars.registerPartial('resultList_geo_namecard_item', $("#tmpl-result-list-geo-namecard-item").html());
        if ($("#tmpl-result-list-geo-tree").html() != undefined)
            this.Handlebars.registerPartial('resultList_geo_tree', $("#tmpl-result-list-geo-tree").html());
        if ($("#tmpl-result-list-geo-tree-item").html() != undefined)
            this.Handlebars.registerPartial('resultList_geo_tree_item', $("#tmpl-result-list-geo-tree-item").html());
        if ($("#tmpl-result-list-person-namecard").html() != undefined)
            this.Handlebars.registerPartial('resultList_person_namecard', $("#tmpl-result-list-person-namecard").html());
        if ($("#tmpl-result-list-person-namecard-item").html() != undefined)
            this.Handlebars.registerPartial('resultList_person_namecard_item', $("#tmpl-result-list-person-namecard-item").html());
        if ($("#tmpl-result-list-corporate-namecard").html() != undefined)
            this.Handlebars.registerPartial('resultList_corporate_namecard', $("#tmpl-result-list-corporate-namecard").html());
        if ($("#tmpl-result-list-corporate-namecard-item").html() != undefined)
            this.Handlebars.registerPartial('resultList_corporate_namecard_item', $("#tmpl-result-list-corporate-namecard-item").html());
        if ($("#tmpl-slider-item").html() !== undefined)
            this.Handlebars.registerPartial('slider_item', $("#tmpl-slider-item").html());
        if ($("#tmpl-result-list-memorial-namecard").html() != undefined)
            this.Handlebars.registerPartial('resultList_memorial_namecard', $("#tmpl-result-list-memorial-namecard").html());
        if ($("#tmpl-result-list-memorial-namecard-item").html() != undefined)
            this.Handlebars.registerPartial('resultList_memorial_namecard_item', $("#tmpl-result-list-memorial-namecard-item").html());
        if ($("#tmpl-result-list-memorial-tree").html() != undefined)
            this.Handlebars.registerPartial('resultList_memorial_tree', $("#tmpl-result-list-memorial-tree").html());
        if ($("#tmpl-result-list-memorial-tree-item").html() != undefined)
            this.Handlebars.registerPartial('resultList_memorial_tree_item', $("#tmpl-result-list-memorial-tree-item").html());
    }
}


